import { Component, inject, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AgGridAngular } from 'ag-grid-angular';
import { GridApi, GridOptions, GridReadyEvent, GridSizeChangedEvent } from 'ag-grid-community';

import { UserService } from '../../../services/user-service/user.service';
import { AgGridService } from '../../../shared/ag-grid/ag-grid.service';
import { BookingApprovalsHistoryModel } from '../model/booking-approvals-history-model';

@Component({
  selector: 'app-booking-approvals-history',
  templateUrl: './booking-approvals-history.component.html',
  imports: [AgGridAngular],
})
export class BookingApprovalsHistoryComponent implements OnInit {
  private readonly translateService = inject(TranslateService);
  private readonly agGridService = inject(AgGridService);
  private readonly userService = inject(UserService);

  @Input()
  public bookingApprovalsHistory: BookingApprovalsHistoryModel[];

  public gridOptions: GridOptions;
  public columnDefs: any;
  public defaultColDef: any;

  private gridApi: GridApi;
  private tmpParam: any;

  public ngOnInit(): void {
    this.setupGrid();
  }

  private setupGrid(): void {
    this.gridOptions = this.agGridService.newDefaultGridOptions();
    this.gridOptions.getLocaleText = this.agGridService.translate(this.userService, this.translateService);
    this.gridOptions.overlayComponentParams = {
      noMatchingRows: { overlayText: this.translateService.instant('noMatchingRows') },
    };
    this.gridOptions.pagination = false;
    this.gridOptions.suppressCellFocus = true;
    this.defaultColDef = {
      sortable: false,
      suppressHeaderMenuButton: true,
      floatingFilter: false,
    };
    this.columnDefs = [
      { headerName: this.translateService.instant('BOOKING_APPROVAL_HISTORY_STEP'), field: 'step', width: 40 },
      { headerName: this.translateService.instant('BOOKING_APPROVAL_HISTORY_DATE'), field: 'date', width: 80 },
      { headerName: this.translateService.instant('BOOKING_APPROVAL_HISTORY_TIME'), field: 'time', width: 80 },
      { headerName: this.translateService.instant('BOOKING_APPROVAL_HISTORY_EDITOR'), field: 'editor', width: 80 },
      {
        headerName: this.translateService.instant('BOOKING_APPROVAL_HISTORY_ACTION'),
        valueGetter: this.agGridService.translateApprovalsHistoryAction(this.translateService),
        width: 120,
      },
    ];
  }

  public onGridSizeChanged(event: GridSizeChangedEvent<any>): void {
    event.api.sizeColumnsToFit();
  }

  public onGridReady(event: GridReadyEvent): void {
    this.tmpParam = event;
    this.gridApi = event.api;
    this.gridOptions.overlayNoRowsTemplate = `<span>${this.translateService.instant(
      'BOOKING_APPROVAL_HISTORY_NO_VALUES',
    )}</span>`;
    this.gridApi.sizeColumnsToFit();
    event.api.setGridOption('rowData', this.bookingApprovalsHistory);
  }

  public refreshTable(newBookingApprovalsHistory: BookingApprovalsHistoryModel[]): void {
    this.bookingApprovalsHistory = newBookingApprovalsHistory;
    this.onGridReady(this.tmpParam);
  }
}
